module.exports = __webpack_public_path__ + "static/media/supeng.868eaa47.jpg";